import React from 'react';

const SectionTitle = ({ title }) => (
  <h1 className="section-title">{title}</h1>
);

export default SectionTitle;
